import React from "react";
import { useLoaderData } from "react-router-dom";
import { loader } from "../hooks/useArticle";
import Four0Four from "./404";
import Block from "../components/blocks";
import Meta from "../components/meta";
const Article = () => {
  const { data, loading } = useLoaderData();

  if (loading || (data && data.article === undefined)) return null;
  else if (!data?.article) return <Four0Four />;

  const article = data.article;

  return (
    <div id="article">
      <Meta
        path={article.path}
        description={article.seo.description || article.title}
        index={article.seo.index}
        title={article.title}
        updated={article.modified}
        image={article.thumbnail?.formats?.thumbnail?.url}
      />
      {data.article.content.rows.map(r => (
        <div key={r.id} className={`row ${r.layout} ${(r.options && r.options.fullWidth ? "fullWidth " : "")} ${(r.options && r.options.noPadding ? "noPadding " : "")}`}>
          {r.columns.map(c => (
            <div key={c.id} className="column">
              {c.blocks.map(b => <Block key={b.id} block={b} />)}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const Loader = async props => {
  return loader(props.params.handle || "/");
};

const Routes = [{
  path: "/:handle",
  element: <Article />,
  loader: Loader
}, {
  path: "/",
  element: <Article />,
  loader: Loader
}];

export default Article;
export { Routes };
